var render = function render(){
  var _vm$estimatedDti, _vm$estimatedDti2, _vm$estimatedDti2$ext, _vm$income;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "header-block"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_vm._v("Orientačný limit úveru podľa DTI")]), _c('div', [_vm.dtiLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")((_vm$estimatedDti = _vm.estimatedDti) === null || _vm$estimatedDti === void 0 ? void 0 : _vm$estimatedDti.value)) + " EUR")])], 1)]), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_vm._v("Akceptovaný príjem / mes.")]), _c('div', [_vm.dtiLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")((_vm$estimatedDti2 = _vm.estimatedDti) === null || _vm$estimatedDti2 === void 0 ? void 0 : (_vm$estimatedDti2$ext = _vm$estimatedDti2.extra) === null || _vm$estimatedDti2$ext === void 0 ? void 0 : _vm$estimatedDti2$ext.prijem_mo)) + " EUR")])], 1)]), (_vm$income = _vm.income) !== null && _vm$income !== void 0 && _vm$income.error ? _c('div', [_c('br'), _vm._l(_vm.income.error, function (error, key) {
    return _c('div', {
      key: key,
      staticClass: "error-text"
    }, [_vm._v(" " + _vm._s(error) + " ")]);
  })], 2) : _vm._e()]), _c('form', {
    attrs: {
      "id": "income-submit"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveIncome.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "income-methodology-note"
  }, [_vm._v(" Materské alebo rodičovský príspevok sa uloží ako doplnkový príjem. Vyberte, či klient poberá materské, a doplňte začiatok poberania. Výšku a akceptáciu následne posúdime podľa nastavenia jednotlivých bánk. ")]), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.suma,
      expression: "form.suma"
    }],
    staticStyle: {
      "opacity": "0",
      "position": "absolute"
    },
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": _vm.form.suma
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "suma", $event.target.value);
      }
    }
  }), _c('dropdown-select', {
    staticClass: "required",
    attrs: {
      "id": 'maternity_recieve',
      "init-value": _vm.form.suma,
      "options": _vm.druhChoices,
      "normal": "",
      "name": 'Poberáte materský príspevok'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'suma');
      }
    }
  })], 1), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.zamestnanyOd,
      expression: "form.zamestnanyOd"
    }],
    staticClass: "text-input w-input date-input",
    attrs: {
      "type": "date",
      "max": _vm.getTodayDate(),
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.zamestnanyOd
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "zamestnanyOd", $event.target.value);
      }
    }
  })])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Zamestnan-od"
    }
  }, [_vm._v("Poberanie materskej "), _c('strong', [_vm._v("od")])]);

}]

export { render, staticRenderFns }